import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_Overlay from 'ol/Overlay';
import * as ReactDOM from 'react-dom';
import { Util } from './util';

export class Overlay extends React.Component {
    constructor() {
        super(...arguments);
        this.options = {
            id: undefined,
            element: undefined,
            offset: undefined,
            position: undefined,
            stopEvent: undefined,
            insertFirst: undefined,
            autoPan: undefined,
            autoPanAnimation: undefined,
            autoPanMargin: undefined
        };
        this.events = {
            'change': undefined,
            'change:element': undefined,
            'change:map': undefined,
            'change:offset': undefined,
            'change:position': undefined,
            'change:positioning': undefined,
            'propertychange': undefined
        };
    }
    render() {
        return (React.createElement("div", null, this.props.children));
    }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        options.element = ReactDOM.findDOMNode(this).querySelector('div');
        //console.log('options.element', options.element);
        this.overlay = new ol_Overlay(options);
        this.context.mapComp.overlays.push(this.overlay);
        if(this.context.map) {
            this.context.map.addOverlay(this.overlay); //hoan:code plugin ko co cai nay nen ko hien thi
        }
        //console.log('mount overlay id', this.props.keyID);
    }
    componentWillReceiveProps(nextProps) {
        this.overlay.setPosition(nextProps.position);
    }
    componentWillUnmount() {
        this.context.mapComp.overlays.splice(this.overlay); //hoan add dong nay
        this.context.mapComp.map.removeOverlay(this.overlay); //hoan add dong nay
        console.log('remove overlay id', this.props.keyID);
    }
}
Overlay['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Object),
    map: PropTypes.instanceOf(ol_Map)
};